module.exports = __webpack_public_path__ + "img/radiance.d2d10aad.png";